import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, ArrowRight, Plus, Trash } from "@phosphor-icons/react";
import { Section, In, Sel } from "./Fields";
import { ID_VERIFIED, readAsDataURL, uid } from "./constants";

export default function TenantStep({ inspection, patch, onNext, onPrev }) {
  const t = inspection.tenant || {};
  const [form, setForm] = useState({
    name: t.name || "", phone: t.phone || "", email: t.email || "",
    move_in_date: t.move_in_date || "", id_verified: !!t.id_verified,
    employment_status: t.employment_status || "", previous_landlord_ref: t.previous_landlord_ref || "",
    comments: t.comments || "", documents: t.documents || [],
  });

  const upd = (k, v) => setForm({ ...form, [k]: v });

  const uploadDocs = async (files) => {
    const docs = [...(form.documents || [])];
    for (const f of Array.from(files)) {
      const data_url = await readAsDataURL(f);
      docs.push({ id: uid(), name: f.name, data_url });
    }
    setForm({ ...form, documents: docs });
  };

  const save = async () => {
    await patch({ tenant: form });
    toast.success("Tenant saved");
    onNext();
  };

  return (
    <Section title="Tenant" subtitle="Tenant details and documents">
      <div className="grid md:grid-cols-2 gap-3">
        <In label="Name" v={form.name} on={(v) => upd("name", v)} test="tenant-name" />
        <In label="Phone" v={form.phone} on={(v) => upd("phone", v)} />
        <In label="Email" v={form.email} on={(v) => upd("email", v)} />
        <In label="Move-in date" type="date" v={form.move_in_date} on={(v) => upd("move_in_date", v)} />
        <Sel label="ID verified" v={form.id_verified ? "Yes" : "No"} on={(v) => upd("id_verified", v === "Yes")} opts={ID_VERIFIED} />
        <In label="Employment status" v={form.employment_status} on={(v) => upd("employment_status", v)} />
        <In label="Previous landlord reference" v={form.previous_landlord_ref} on={(v) => upd("previous_landlord_ref", v)} full />
        <In label="Tenant comments" v={form.comments} on={(v) => upd("comments", v)} full textarea />
      </div>

      <div className="mt-6">
        <div className="text-xs font-semibold uppercase tracking-wider text-[#6B7280] mb-2">Documents</div>
        <label className="border border-dashed border-[#E5E7EB] rounded-md p-4 inline-flex items-center gap-2 cursor-pointer hover:border-[#1E3A5F]">
          <Plus size={14} /> Upload documents
          <input type="file" multiple className="hidden" onChange={(e) => uploadDocs(e.target.files)} />
        </label>
        {form.documents?.length > 0 && (
          <div className="mt-3 space-y-1 text-sm">
            {form.documents.map((d, i) => (
              <div key={d.id || `${d.name}-${i}`} className="flex items-center justify-between border border-[#E5E7EB] rounded-sm px-3 py-2">
                <span>{d.name}</span>
                <button
                  onClick={() => setForm({ ...form, documents: form.documents.filter((_, x) => x !== i) })}
                  className="text-[#991B1B]"
                >
                  <Trash size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="flex justify-between mt-8 pt-6 border-t border-[#E5E7EB]">
        <button onClick={onPrev} className="trent-btn-secondary">
          <ArrowLeft weight="bold" size={14} /> Back
        </button>
        <button onClick={save} className="trent-btn-primary" data-testid="wizard-next-6">
          Save & continue <ArrowRight weight="bold" size={14} />
        </button>
      </div>
    </Section>
  );
}
